'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILE_MANAGER_API_PREFIX = exports.FILE_MANAGER_API_PREFIX = 'filemanager/api';

var TEN_MEGABYTES_IN_BYTES = 10485760;

var MAX_FILE_SIZE = exports.MAX_FILE_SIZE = TEN_MEGABYTES_IN_BYTES;

var MAX_UPLOAD_PROGRESS_PERCENTAGE = exports.MAX_UPLOAD_PROGRESS_PERCENTAGE = 95;


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/constants/fileUploadsConstants.js
// module id = 119
// module chunks = 2 3